import { AppThunk, ActionNames } from 'src/types/actions';
import {
  CreatorApplication,
  UpdateCreatorApplicationAction,
  ResetCreatorApplicationAction,
} from 'src/types/models/creatorApplication.model';

export function updateCreatorApplication(
  payload: Partial<CreatorApplication>,
): UpdateCreatorApplicationAction {
  return {
    type: ActionNames.UPDATE_CREATOR_APPLICATION,
    payload,
  };
}

export function resetCreatorApplication(): ResetCreatorApplicationAction {
  return {
    type: ActionNames.RESET_CREATOR_APPLICATION,
    payload: undefined,
  };
}

export const apply = (): AppThunk => {
  return async (dispatch, getState, { services }) => {
    const { cloud } = services;
    const { creatorApplication } = getState();

    // Remove channels that are empty
    const channels = creatorApplication.channels.filter(
      ({ name, url }) => !(name === '' && url === ''),
    );

    await cloud.call('contentCreator-apply')({
      ...creatorApplication,
      channels,
    });

    dispatch(resetCreatorApplication());
  };
};
